<template>
  <v-dialog v-model="dialog" persistent max-width="510">
    <v-card>
      <v-card-title class="headline">Choose IP Range</v-card-title>
      <v-card-text>{{text}}</v-card-text>
      <v-card-actions>
        <v-btn v-if="!isIPoE" color="darken-1" @click="onBtnClick('29')">Ip Range /29</v-btn>
        <v-btn v-if="!isIPoE" color="darken-1" @click="onBtnClick('30')">Ip Range /30</v-btn>
        <v-btn color="darken-1" @click="onBtnClose()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ip-range",
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    isIPoE: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onBtnClick (ipRange) {
      this.$emit(`onBtnClick`, ipRange);
    },
    onBtnClose () {
      this.$emit(`onClose`);
    },
  }
}
</script>
